import React from "react";
import { Tag } from "antd";
import trans from "../../../../utils";
import PopupBodyItem from "../../../Helpers/Popup/PopupParts/PopupBodyItem";

export default function SnagOfflineInf({ formEditData }) {
	const getValue = (value, defaultValue = "-----") =>
		value ? value : defaultValue;
	console.log("FormEditData", formEditData);
	const {
		discipline = "",
		project_name = "",
		zone_name = "",
		level_name = "",
		room_name = "",
		status = "",
	} = formEditData;
	const statusColor = {
		"Pending Sync": `orange`,
		Synced: "green",
		Failed: "red",
		Syncing: "blue",
	};
	return (
		<div>
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("Snag Details")}
			</p>
			<div className="row">
				<div className="col-lg-6">
					<div className="display-border">
						<PopupBodyItem
							title={trans("Project")}
							item={getValue(project_name)}
						/>
						<PopupBodyItem title={trans("Level")} item={getValue(level_name)} />

						<PopupBodyItem
							title={trans("Discipline")}
							item={trans(getValue(discipline))}
						/>
					</div>
				</div>
				<div className="col-lg-6">
					<div className="display-border">
						{/* ✅ UPDATED - Level from relation */}
						<PopupBodyItem title={trans("Zone")} item={getValue(zone_name)} />

						{/* ✅ NEW - Room field */}
						<PopupBodyItem title={trans("Space")} item={getValue(room_name)} />

						<PopupBodyItem
							title={trans("Status")}
							item={getValue(
								<Tag color={statusColor[status] || "default"}>
									{trans(status)}
								</Tag>,
							)}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
